import {
	ACTIVE_SPRINT_STATE,
	CLOSED_SPRINT_STATE,
	FUTURE_SPRINT_STATE,
} from '@atlassian/jira-shared-types';
import type { SprintValue, SprintFieldValue } from '../../common/types';
import { findSprintWithState, hasState } from '../../common/utils';

export const getActiveOrFutureSprint = (value: SprintFieldValue | null): SprintValue | null => {
	const activeSprint = findSprintWithState(value, ACTIVE_SPRINT_STATE);
	if (activeSprint) return activeSprint;

	const futureSprint = findSprintWithState(value, FUTURE_SPRINT_STATE);
	if (futureSprint) return futureSprint;

	return null;
};

export const getClosedSprints = (value: SprintFieldValue | null): SprintFieldValue => {
	if (!value) {
		return [];
	}

	return value.filter(hasState(CLOSED_SPRINT_STATE));
};
